import {string,object} from "yup";

export default object().shape({
  principalName: string().required().min(1).default(''),
  password: string().required().min(1).default('')
});